import { render, staticRenderFns } from "./InformacaoChaveModal.vue?vue&type=template&id=0684b36a&"
import script from "./InformacaoChaveModal.vue?vue&type=script&lang=js&"
export * from "./InformacaoChaveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports